
const DEFAULT_KEY = '14959'
const BASE_URL = "https://admincontrol.liveonplus.it/node_api/";
// const BASE_URL = "http://192.168.7.37:8001/node_api/";



const PAYPAL_CLIENT_ID = "Ad077-Gx8stGcfWQYawBiQUc4UbKWIRIg_PK4lHL4pzHR-uOPMz2vCk_jQ8QU9pcEw0j8U3UYDrEUS75"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }

